export function PlusCircleIcon({ className }: { className?: string }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M12.0001 8V16M8.00012 12H16.0001M22.0001 12C22.0001 17.5228 17.523 22 12.0001 22C6.47727 22 2.00012 17.5228 2.00012 12C2.00012 6.47715 6.47727 2 12.0001 2C17.523 2 22.0001 6.47715 22.0001 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "PlusCircleIcon";
